import React from 'react';
import {
  ATMContainer,
  ATMHeader,
  ATMButton,
  ATMDropdown,
  ORGDataTable,
  IORGDataTableColumn,
} from 'shared-it-appmod-ui';
import Lang from 'src/libraries/language';
import { NotificationRequestStatus } from 'src/constants';
import { INotification } from 'src/models/notification.model';
import NotificationRow from './notification-row/notification-row.component';
import style from './notification.module.scss';

export type IProps = {
  data: INotification[];
  handleRefresh: (params) => void;
  loading?: boolean;
  total?: number;
  param: Record<string, unknown>;
};

const NotificationView: React.FC<IProps> = ({
  data,
  handleRefresh,
  loading,
  total = 0,
  param,
}) => {
  const customColumns: IORGDataTableColumn<INotification>[] = [
    {
      title: null,
      index: 'a',
      render: (_, value) => <NotificationRow value={value} />,
    },
  ];

  // for UT Coverage
  if (process.env.REACT_APP_SWITCH_TO_UNIT_TEST_MODE === 'true') {
    if (customColumns[0].render) {
      customColumns[0].render(true, {} as INotification, 1, {} as any);
    }
  }

  return (
    <ATMContainer className={style.container}>
      <div className={style.header}>
        <ATMHeader
          as="h1"
          content={Lang.TTL_NOTIFICATIONS}
          style={{ float: 'left' }}
        />
        <div>
          <ATMDropdown
            placeholder={Lang.LBL_SELECT}
            options={Object.entries(NotificationRequestStatus).map(
              ([key, value]) => ({
                key,
                value,
                text: value,
              })
            )}
            selection
            clearable
            selectOnBlur={false}
            style={{ verticalAlign: 'initial', float: 'right' }}
            onChange={(_, val) => handleRefresh({ status: val.value })}
          />
          <ATMButton
            className={style.actionIcon}
            basic
            icon="refresh"
            onClick={() => handleRefresh(param)}
          />
        </div>
      </div>

      <ORGDataTable
        celled={false}
        columns={customColumns}
        data={data}
        loading={loading}
        total={total}
        showPagination={false}
      />
    </ATMContainer>
  );
};

export default NotificationView;
